import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { ADMIN_ENV, headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";

const { get } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "member";

type GetBenefitMemberProjectionAPIProps = {
	group_number: number;
	enrollment_type: string;
	plan_name: string;
	map_type: string;
};
export const getBenefitMemberProjection = async (_apiPayload: GetBenefitMemberProjectionAPIProps) => {
	const { group_number, enrollment_type, plan_name, map_type } = _apiPayload;
	try {
		const endpoint = `${initialRoute}/benefit-summary/active-benefit-member-projection?group_number=${group_number}&enrollment_type=${enrollment_type}&plan_name=${plan_name}&map_type=${map_type}`;
		const token = localStorage.getItem("@jwt");
		const response = await get(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			// alert(message);
			if (ADMIN_ENV == "DEV") {
				console.log("Failed to fetch data");
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			if (ADMIN_ENV == "DEV") {
				console.log("Failed to fetch data");
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		} else {
			throw error;
		}
	}
};
